<template>
  <div>
      <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Configuración</strong>
            </h5>
          </div>
        </div>
        <template v-if="config === 0">
          <b-row align-v="stretch">
            <b-col>
              <b-card class="h-100">
                <b-row>
                  <b-col>
                    <h4>General</h4>
                  </b-col>
                </b-row>
                <b-row class="pt-4">
                  <!-- <b-col sm="12" lg="6" xl="4">
                    <nomina-widget-item-2 title="Datos básicos" icon="fe fe-clipboard" iconColor="color: #3ea7df"
                      backgroundColor="bg-info" borderColor="border-top-color: #3ea7df" :dataConfig="1" v-on:set-config="setConfig"
                      description="Nit, nombre y ubicación de la empresa"/>
                  </b-col> -->
                  <b-col sm="12" lg="6">
                    <nomina-widget-item-2 title="Datos de pago" icon="fe fe-credit-card" iconColor="color: #d6dce5"
                    backgroundColor="bg-gray-2" borderColor="border-top-color: #d6dce5" :dataConfig="2" v-on:set-config="setConfig"
                    description="Método y frecuencia de pago y fecha de liquidación"/>
                  </b-col>
                  <b-col sm="12" lg="6">
                    <nomina-widget-item-2 title="Aportes a seguridad social" iconColor="color: #38996e"
                    backgroundColor="bg-success" borderColor="border-top-color: #38996e" :dataConfig="3" v-on:set-config="setConfig"
                    description="ARL"/>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <h4>Conceptos</h4>
                  </b-col>
                </b-row>
                <b-row class="pt-4">
                  <b-col sm="12" lg="6">
                    <nomina-widget-item-2 title="Devengados de la empresa" iconColor="color: #eba214" icon="fe fe-arrow-up-circle"
                    backgroundColor="bg-orange" borderColor="border-top-color: #eba214" :dataConfig="4" v-on:set-config="setConfig"
                    description="Lista de devengados (salario, auxilio de transporte, horas extras, entre otros.)"/>
                  </b-col>
                  <b-col sm="12" lg="6">
                    <nomina-widget-item-2 title="Deducciones de la empresa" iconColor="color: #4e5188" icon="fe fe-arrow-down-circle"
                    backgroundColor="bg-gray-6" borderColor="border-top-color: #4e5188" :dataConfig="5" v-on:set-config="setConfig"
                    description="Lista de deducciones (salud, fondo de pensiones, deuda, entre otros.)"/>
                  </b-col>
                </b-row>
                <!-- <b-row>
                  <b-col>
                    <p>Para completar los <strong>datos básicos de la empresa</strong> <a @click="setConfig(1)" class="link-style">haz click aquí.</a></p>
                    <p>Para configurar los <strong>datos de pago</strong> <a class="link-style">haz click aquí.</a></p>
                    <p>Para configurar los <strong>aportes a seguridad social</strong> <a class="link-style">haz click aquí.</a></p>
                    <h1>Conceptos</h1>
                    <p>Gestionar los <strong>devengados de la empresa</strong> <a class="link-style">haz click aquí.</a></p>
                    <p>Gestionar las <strong>deducciones de la empresa</strong> <a class="link-style">haz click aquí.</a></p>
                  </b-col>
                </b-row> -->
              </b-card>
            </b-col>
          </b-row>
        </template>
        <template v-if="config === 2">
          <paymentSettings :idSchool="this.$store.state.user.idSchool" v-on:set-config="setConfig"/>
        </template>
        <template v-if="config === 3">
          <socialSecuritySettings :idSchool="this.$store.state.user.idSchool" v-on:set-config="setConfig"/>
        </template>
        <template v-if="config === 4">
          <accrualSettings :idSchool="this.$store.state.user.idSchool" v-on:set-config="setConfig"/>
        </template>
        <template v-if="config === 5">
          <deductionSettings :idSchool="this.$store.state.user.idSchool" v-on:set-config="setConfig"/>
        </template>
  </div>
</template>
<script>
// import basicSettings from '@/components/custom/nomina/settings/basicSettings/basicSettings.vue'
import paymentSettings from '@/components/custom/nomina/settings/paymentSettings/paymentSettings.vue'
import socialSecuritySettings from '@/components/custom/nomina/settings/socialSecurity/socialSecuritySettings.vue'
import accrualSettings from '@/components/custom/nomina/settings/accrualSettings/accrualSettings.vue'
import deductionSettings from '@/components/custom/nomina/settings/deductionSettings/deductionSettings.vue'
import nominaWidgetItem2 from '@/components/custom/nomina/widgets/item2'
// import apiClient from '@/services/axios'
// import apiClient2 from '@/services/axios/v2.js'
// import axios from 'axios'

export default {
  components: {
    // basicSettings,
    paymentSettings,
    socialSecuritySettings,
    accrualSettings,
    deductionSettings,
    nominaWidgetItem2,
  },
  name: 'ManagementEmployee',
  data() {
    return {
      config: 0,
    }
  },
  methods: {
    setConfig(value) {
      this.config = value
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
  },
}
</script>
<style>
  .link-style {
    color: inherit;
    text-decoration: none;
  }

  .link-style {
    background:
      linear-gradient(
        to right,
        rgba(100, 200, 200, 1),
        rgba(100, 200, 200, 1)
      ),
      linear-gradient(
        to right,
        rgb(255, 255, 255),
        rgb(29, 117, 206)
    );
    background-size: 100% 3px, 0 3px;
    background-position: 100% 100%, 0 100%;
    background-repeat: no-repeat;
    transition: background-size 400ms;
  }

  .link-style:hover {
    background-size: 0 3px, 100% 3px;
  }
</style>
